var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('blog-block',_vm._b({},'blog-block',_vm.block,false),[_vm._l((_vm.block.content),function(content){return _c('blog-block-content',_vm._b({key:content.id},'blog-block-content',content,false))})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }